export class ValidationUtils {

    email(email: any): boolean {
        const email_pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return email_pattern.test(email);
    }

    mobile(mobile: any): boolean {
        const phone_pattern = new RegExp(/^[0-9]{10}$/);
        return phone_pattern.test(mobile);
    }

    telephone(telephone: any): boolean {
        const phone_pattern = new RegExp(/^[0-9]{7,15}$/);
        return phone_pattern.test(telephone);
    }

    password(password: string): boolean {
        const password_pattern = new RegExp(/^(?=.*[A-Z])(?=.*[!@#\\$%\\^&\\*])(.{8,50})$/)
        return password_pattern.test(password);
    }

    year(year: any): boolean {
        const pattern = new RegExp(/^[0-9]{4}$/);
        if (pattern.test(year) && (year <= new Date().getFullYear())) {
            return true;
        } else {
            return false;
        }
    }

    positiveNumber(number: Number): boolean {
        if (number.valueOf() < 0)
            return false;
        else
            return true;
    }

    restrictSpecialChar(value: any): boolean {
        // const pattern = new RegExp(/[^A-Za-z\d]/);
        const pattern = new RegExp("^[a-zA-Z0-9 ]+$");
        return pattern.test(value);
    }

    //
    validateAlphaNumeric(value: any):boolean {
        // console.log(typeof(value));
        const pattern = this.email(value);
        const pattern1 = RegExp(/^[0-9]{10}$/);
        const x = pattern;
        const y = pattern1.test(value);
        if( x === true && y === false) {
            let mobile = this.email(value);
            if(mobile === false) {
                return false;
            } else {
                return true;
            }
        } else {
            let mobile = this.mobile(value);
            if(mobile === false) {
                return false;
            } else {
                return true;
            }
        }
        
    }

    validateGSTNumber(value: any): boolean {
        let pattern = RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
        // console.log(pattern.test(value))
        if(pattern.test(value) === true) {
            return true;
        } else {
            return false;
        }
    }

    validatePincode(value: any): boolean {
        let pattern = RegExp(/^[0-9]{6}$/);
        if(pattern.test(value) === true) {
            return true;
        } else {
            return false;
        }
    }
}